module.exports = __webpack_public_path__ + "img/custom_bg2.c3855c16.png";